<template>
  <div @click="goNext" class="index" v-bind:style="{backgroundImage:'url(' + bg_img + ')'}">
      <h3 ref="title" class="title animated fadeInRight"><span>游梓公寓</span></h3>
      <h3 ref="names" class=" animated fadeInRight">一站式英国订房服务</h3>
      <div class="us-item">
          <img ref="img" class="index-bottom animated fadeInLeft" src="https://cdn.hanlandglobal.com/h5-us-bg.png" />
          <p ref="content" class="animated fadeInRight">游梓公寓隶属北京游梓网络科技有限公司，于2018年02月02日成立，自成立日起与英国知名主流公寓商合作，整合全英优质公寓资源，为留学生提供公寓预定服务。</p>
      </div>
      <img ref="gif" class="gif-img animated fadeIn" :src="gif" />      
  </div>
</template>

<script>
// @ is an alias to /src
import bg_img from '../assets/image/h5-bg.png'
import button_img from '../assets/image/button-bg.png'
import gif from '../assets/image/shouzhi.gif'

export default {
  name: 'Home',
  data(){
    return {
      bg_img,
      button_img,
      gif
    }
  },
  mounted(){
    // let opacitys = 0.3
    // this.timer = setInterval(() => {
    //    if(opacitys < 1){
    //        opacitys = opacitys + 0.03
    //       this.$refs.usbg.style.opacity = opacitys
    //    }else{
    //        clearInterval(this.timer)
    //    }
    // }, 100);
  },
  methods:{
      goNext:function(){
         this.$refs.img.className = 'index-bottom animated fadeOutDown'
         this.$refs.content.className = 'animated fadeOutUp'
         this.$refs.title.className = 'title animated fadeOutUp'
         this.$refs.names.className = ' animated fadeOutRightBig'
         this.$refs.gif.className = 'gif-img gif animated fadeOut'
          setTimeout(()=>{
            this.$router.push('/story')
          },600)
      }
  },
  destroyed(){
    clearInterval(this.timer)
  }
}
</script>
<style lang='scss' scoped>
.index{
  width: 100%;
  height: 100vh;
  background-repeat: no-repeat;
  background-size: 100% 100vh;
  position: relative;
  animation-duration: 1.5s;
}
.title{
    padding-top:13.6vh;
}
h3{
  font-size: 0.36rem;
  font-weight: 700;
  font-family: SourceHan;
  color: #4d372e;
  text-align: center;
  letter-spacing: 1px;
  text-align: right;
  margin-right: 0.6rem;
  span{
    font-size: 0.6rem;
  }
}
.index-bottom{
  width: 6.84rem;
  height: 7.65rem;
  position: absolute;
  left: -3rem;
  bottom: 0;
}
.us-item{
    p{
      width: 2.8rem;
      // font-family: SourceHan;
      font-size: 0.28rem;
      font-stretch: normal;
      text-align: left;
      line-height: 0.56rem;
      letter-spacing: 1px;
      color: #543f3c;
      position: absolute;
      right: 0.3rem;
      margin-top: 6vh;
      // bottom:4.2rem;
    }
}
.gif-img{
  position:absolute;
  width: 2.7rem;
  height: 1.98rem;
  z-index: 999;
  bottom: 0.2rem;
  right: 0.2rem;
  animation-delay: 0.8s; 
}
.gif{
    animation-delay: 0s; 
}
</style>
